import { useApi } from './useApi'

export const useVoluntarios = () => {
  const api = useApi()

  // { fecha, total, capitanes, voluntarios, personas: [{ nombre, whatsapp, rol, congregacion, turnos }] }
  const getVoluntariosDia = (fecha) =>
    api.get(`/api/voluntarios/dia?fecha=${encodeURIComponent(fecha)}`)

  return { getVoluntariosDia }
}
